export default {
    addBaseLayer(state, layerObj) {
        if (state.controlLayers.has(layerObj.name)) {

            console.warn(`${layerObj.name} has been added to controlLayers`)
        }
        state.controlLayers.set(layerObj.name, layerObj.layer)
    },
    addLayer(state, layerObj) {
        let { name, layer } = layerObj
        if (state.mapLayers.has(name)) {
            console.warn(`${name} has been added to layers`)

        }
        state.mapLayers.set(name, layer)
    },
    addControlMap(state, mapObj) {
        if (state.controlMaps.has(mapObj.name)) {
            console.warn(`${mapObj.name} has been added to controlMaps`)
        }

        state.controlMaps.set(mapObj.name, mapObj.map)
    },
    setCurrentMap(state, map) {
        if (map) {
            state.currentMap = map
        }
    },
    addVueDom(state, data) {
        let vueDomPool = state.vueDomPool
        // if (!vueDomPool.get(data.domName)) {
        //if 会导致新的组件不能加载，从而出现进度条不显示的问题
        vueDomPool.set(data.domName, data.dom)
        // }
    },
    saveShipList(state, saveobj) {
        state.fishShipList.set(saveobj.listname, saveobj.data)
    },
    setUser(state, user) {
        state.user = user
    },
    /**
     * 清除所有的地图工具
     * @param {*} state
     * @param {*} param
     */
    clearAllMapTool(state, options = {}) {
        //hrf 新增 可以选择保留某些选项
        let excludes = options.excludes || []
        //取消单点查询
        if (!excludes.includes('MAP') && state.vueDomPool.has("MAP")) {
            let mapObj = state.vueDomPool.get("MAP");
            mapObj.clearSingle();
        }

        //取消测量
        if (!excludes.includes('MAPTOOL') && state.vueDomPool.has("MAPTOOL")) {
            let mapToolObj = state.vueDomPool.get("MAPTOOL");
            mapToolObj.removeMeasure();
            //同时清除绘制
            mapToolObj.clearDraw()
        }

        //取消绘制
        if (!excludes.includes('FISHERDRAW') && state.vueDomPool.has("FISHERDRAW")) {
            let fisherDrawObj = state.vueDomPool.get("FISHERDRAW");
            fisherDrawObj.stopDraw();
            // fisherDrawObj.clearFeature();
        }
    },

    //设置MMSMap
    setMMSIMap(state, params) {
        state.MMSIMap = params;
    },
    setUserRole(state, role) {
        state.userRole.clear()
        if (Array.isArray(role)) {
            role.forEach(item => {
                if (typeof item == "string") {
                    state.userRole.set(item, true)
                } else if (typeof item == "object") {
                    state.userRole.set(item.enName, item)
                }
            })
        }
    },
    setUserRights(state, rights) {
        state.userRights.clear()
        if (Array.isArray(rights)) {
            rights.forEach(right => {
                if (typeof right == "string") {
                    // 原权限
                    state.userRights.set(right, true)
                } else if (typeof right == "object") {
                    // 新权限
                    state.userRights.set(right.enName, right)

                }

            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js